function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React from "react";
import Heading from "@amzn/meridian/heading";
import Column from "@amzn/meridian/column";
import useInlineHelpContentActions from "../hooks/useInlineHelpContentActions";
import useInlineHelpContent from "../hooks/useInlineHelpContent";
import useDownloadTermManualActions from "../hooks/useDownloadTermManualActions";
import LoadingComponent from "../components/atoms/LoadingComponent";
import ContentRenderer from "../components/molecules/ContentRenderer";
import { FOOTER, HEADER, KEY_HEADING, OVERVIEW } from "../constants/common";
var SheetContent = function(param) {
    var pageId = param.pageId;
    var downloadTermManual = useDownloadTermManualActions().downloadTermManual;
    var isLoading = useInlineHelpContentActions().isLoading;
    var response = useInlineHelpContent().response;
    if (isLoading) {
        return /*#__PURE__*/ React.createElement(LoadingComponent, {
            isLoading: isLoading
        });
    }
    if (!response) {
        return null;
    }
    var parsedResponse = JSON.parse(response);
    var propertyNames = Object.keys(parsedResponse);
    var renderSheetContent = function(keyNames) {
        var sheetContent = [];
        var keyProperties = keyNames;
        if (keyNames.includes(HEADER)) {
            var _parsedResponse;
            sheetContent.push(/*#__PURE__*/ React.createElement(Heading, {
                level: 1
            }, (_parsedResponse = parsedResponse) === null || _parsedResponse === void 0 ? void 0 : _parsedResponse.header));
        }
        // Swapping to maintain overview and keyTerm order
        if (keyNames.includes(OVERVIEW) && keyNames.includes(KEY_HEADING)) {
            var overviewIndex = keyNames.indexOf(OVERVIEW);
            keyProperties[keyNames.indexOf(KEY_HEADING)] = OVERVIEW;
            keyProperties[overviewIndex] = KEY_HEADING;
        }
        sheetContent = _to_consumable_array(sheetContent).concat(_to_consumable_array(keyProperties.filter(function(keyName) {
            return keyName.toLowerCase() !== HEADER && keyName.toLowerCase() !== FOOTER;
        }).map(function(propertyName) {
            var propertyValues = JSON.parse(parsedResponse[propertyName]);
            return /*#__PURE__*/ React.createElement(ContentRenderer, {
                title: propertyValues.title,
                contentType: propertyValues.contentType,
                content: propertyValues.content,
                onDownloadBtnClick: function(termKey) {
                    return downloadTermManual(termKey);
                }
            });
        })));
        if (keyNames.includes(FOOTER)) {
            var propertyValues = JSON.parse(parsedResponse.footer);
            sheetContent.push(/*#__PURE__*/ React.createElement(ContentRenderer, {
                title: propertyValues.title,
                contentType: propertyValues.contentType,
                content: propertyValues.content,
                onDownloadBtnClick: function(termKey) {
                    return downloadTermManual(termKey);
                }
            }));
        }
        return sheetContent;
    };
    return /*#__PURE__*/ React.createElement(Column, null, renderSheetContent(propertyNames.sort()));
};
export default SheetContent;

//# sourceMappingURL=SheetContent.js.map